// code / i18n key
export const formStateOptions = {
  start: "kidney.form.machine.session.start",
  continue: "kidney.form.machine.session.continue",
  end: "kidney.form.machine.session.end",
};

export const getFormStateMsg = (option, formatMethod) => {
  if (!option || !formStateOptions[option]) return "";
  return formatMethod({ id: formStateOptions[option] });
};

/**
 * 
 * @param {*} formatMethod : props.intl.formatMessage
 * @returns a key message object:
 * {
    "": "",
    start: props.intl.formatMessage({ id: "kidney.form.machine.session.start"" }),
    ...
 */
export const getSessionStateOptionsMap = (formatMethod) => {
  return Object.fromEntries(Object.entries(formStateOptions).map(([key, value]) => [key, !value || value === "" ? "" : formatMethod({ id: value })]));
};

// code / i18n key
export const optionsBloodViscosity = {
  "": "",
  clear: "kidney.form.machine.liquid_aspect_clear",
  "straw-yellow": "kidney.form.machine.liquid_aspect_straw_yellow",
  cloudy: "kidney.form.machine.liquid_aspect_cloudy",
  bloody: "kidney.form.machine.liquid_aspect_bloody",
  pink: "kidney.form.machine.liquid_aspect_pink",
  milky: "kidney.form.machine.liquid_aspect_milky",
  pseudochyle: "kidney.form.machine.liquid_aspect_pseudochyle",
  lymphoid: "kidney.form.machine.liquid_aspect_lymphoid",
  fibrin: "kidney.form.machine.liquid_aspect_fibrin",
  "noninfectious-cloudy": "kidney.form.machine.liquid_aspect_noninfectious_cloudy",
};

export const getBloodViscosityMsg = (option, formatMethod) => {
  if (!option) return "";
  return formatMethod({ id: optionsBloodViscosity[option] });
};

/**
 * 
 * @param {*} formatMethod : props.intl.formatMessage
 * @returns a key message object:
 * {
    "": "",
    clear: props.intl.formatMessage({ id: "kidney.form.machine.liquid_aspect_clear" }),
    "straw-yellow": props.intl.formatMessage({ id: "kidney.form.machine.liquid_aspect_straw_yellow" }),
    ...
 */
export const getBloodViscosityOptionsMap = (formatMethod) => {
  return Object.fromEntries(Object.entries(optionsBloodViscosity).map(([key, value]) => [key, !value || value === "" ? "" : formatMethod({ id: value })]));
};
